import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "message-extras-top" }
const _hoisted_2 = { class: "message-extras-title" }

import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";

interface MessageExtrasWrapperProps {
  title: string;
  icon?: IconType;
  isMine?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageExtrasWrapper',
  props: {
    title: {},
    icon: {},
    isMine: { type: Boolean }
  },
  setup(__props: any) {



const selectedMessageIds = useComputedValue<string[] | null>(
  GetterTypes.GET_SELECTED_MESSAGE_IDS,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-extras", { isSelecting: !!_unref(selectedMessageIds), isMine: !!_ctx.isMine }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.icon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})